import SingleRoleRoute from './SingleRoleRoute';

export default SingleRoleRoute;
